import React from 'react'
import Order from '../features/order/Components/Order'

const OrderHistoryPages = () => {
  document.title = 'Order History';
  
  return (
    <Order />
  )
}

export default OrderHistoryPages